import { HttpsCallableFactory } from "./functions"

import type { Jobseeker } from "interfaces/IJobseeker"
import type { JobseekerId } from "interfaces/IJobseeker"
import type { RecruitId } from "interfaces/RecruitIF"

const hcf = new HttpsCallableFactory("jobseeker")

interface InterestedPayload {
  jobseekerId: JobseekerId
  recruitId: RecruitId
}

export const getJobseeker = hcf.callFunction<void, Jobseeker[]>("getJobseeker")

export const addInterested = hcf.callFunction<InterestedPayload, void>(
  "addInterested",
)

export const removeInterested = hcf.callFunction<InterestedPayload, void>(
  "removeInterested",
)
